'use strict';

module.exports = require('./src/plugin');
